
import React from 'react';

const Bluetooth = ({ width = 10, height = 16, color = '#6D7878', ...props }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 10 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M4.64583 15.1458V10L1.39583 13.25C1.24306 13.4028 1.04861 13.4792 0.8125 13.4792C0.576389 13.4792 0.381944 13.4028 0.229167 13.25C0.0763889 13.0972 0 12.9028 0 12.6667C0 12.4306 0.0763889 12.2361 0.229167 12.0833L4.3125 8L0.229167 3.91667C0.0763889 3.76389 0 3.56944 0 3.33333C0 3.09722 0.0763889 2.90278 0.229167 2.75C0.381944 2.59722 0.576389 2.52083 0.8125 2.52083C1.04861 2.52083 1.24306 2.59722 1.39583 2.75L4.64583 6V0.854167C4.64583 0.604167 4.72917 0.399306 4.89583 0.239583C5.0625 0.0798611 5.25694 0 5.47917 0C5.59028 0 5.69444 0.0208333 5.79167 0.0625C5.88889 0.104167 5.97917 0.166667 6.0625 0.25L9.64583 3.83333C9.72917 3.91667 9.78819 4.00694 9.82292 4.10417C9.85764 4.20139 9.875 4.30556 9.875 4.41667C9.875 4.52778 9.85764 4.63194 9.82292 4.72917C9.78819 4.82639 9.72917 4.91667 9.64583 5L6.64583 8L9.64583 11C9.72917 11.0833 9.78819 11.1736 9.82292 11.2708C9.85764 11.3681 9.875 11.4722 9.875 11.5833C9.875 11.6944 9.85764 11.7986 9.82292 11.8958C9.78819 11.9931 9.72917 12.0833 9.64583 12.1667L6.0625 15.75C5.97917 15.8333 5.88889 15.8958 5.79167 15.9375C5.69444 15.9792 5.59028 16 5.47917 16C5.25694 16 5.0625 15.9201 4.89583 15.7604C4.72917 15.6007 4.64583 15.3958 4.64583 15.1458ZM6.3125 6L7.89583 4.41667L6.3125 2.875V6ZM6.3125 13.125L7.89583 11.5833L6.3125 10V13.125Z"
      fill={color}
    />
  </svg>
);

export default Bluetooth;